export const STATIC_PAGES = ['signin', 'login', 'profile', 'register', 'e_checkout', 'e_catalog', 'e_product', 'e_cart']
